import { ElNotification } from 'element-plus'

export default {
  methods: {
    $toast (content: string, properties: { iconClass?: string, [option: string]: unknown } = {}) {
      const iconClass = properties.iconClass || 'bx bx-bell'
      ElNotification({
        ...properties,
        iconClass: null,
        dangerouslyUseHTMLString: true,
        message: '<div class="notification-content"><i class="' + iconClass + '"></i> ' + content + '</div>',
        position: 'bottom-right'
      })
    },
    close () {
      ElNotification.closeAll()
    }
  }
}
